<script>

import { formatCell } from '../Utils.js';
let props = $props();

</script>

<table class="table query-results">
    <thead>
        <tr>
            {#each props.results.head.vars as column}
                <th>{column}</th>
            {/each}
        </tr>
    </thead>
    <tbody>
        {#each props.results.results.bindings as row}
            <tr>
                {#each Object.entries(row).sort((a, b) => {
                    return props.results.head.vars.indexOf(a[0]) - props.results.head.vars.indexOf(b[0]);
                }) as [attr, data]}
                    <td>{@html formatCell(data)}</td>
                {/each}
            </tr>
        {/each}
    </tbody>
</table>
